import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { GameProvider } from "../state/GameProvider";
import { GameErrorBoundary } from "../components/shell/GameErrorBoundary";
import { Workbench } from "./Workbench";
import "../styles/index.css";
import "./workbench.css";
import "./design.css";
import "./reading-layout.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode><GameProvider><GameErrorBoundary><Workbench /></GameErrorBoundary></GameProvider></StrictMode>,
);
